export default __webpack_public_path__ + "static/media/aluminum.9a23bf7e.png";